'use strict';

/* eslint-disable no-param-reassign */

// Wrap each Client Profiler API function in a safety net with warnings

var apiFunctionNames = ['profile', 'profileIntervalBegin', 'profileIntervalEnd', 'profileIntervalFail'];

var exportedFunctions = apiFunctionNames.reduce(function (apiFunctions, apiFuncName) {
    var apiFunction = function apiFunction() {
        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        // Only attempt to call through to the client profiler if the window is available, because
        // if not, it means we're on the server, and client profiler calls are not applicable
        if (typeof window !== 'undefined') {
            if (typeof window.ClientProfiler !== 'undefined') {
                var _window$ClientProfile;

                (_window$ClientProfile = window.ClientProfiler)[apiFuncName].apply(_window$ClientProfile, args);
            } else {
                // Warn if the client profiler singleton is not available
                console.warn('Attempted to call window.ClientProfiler.' + apiFuncName + '(' + [].concat(args) + ') before the client profiler was ready');
            }
        }
    };
    apiFunctions[apiFuncName] = apiFunction;
    return apiFunctions;
}, {});

module.exports = exportedFunctions;